export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Colonne contese"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset"])}
}